import React, { useState, useEffect } from "react";
import { useUserContext } from "src/contexts/userContext";
import * as API from "src/api/request";
import ResponsiveDataTable from "src/components/ResponsiveDataTable";
import { Column } from "primereact/column";
import { Image } from "primereact/image";

import { InputNumber, Input, Select } from "antd";
import Swal from "sweetalert2";
import _ from "lodash";
// import _ from "lodash";

const Size = () => {
  const { user } = useUserContext();

  const [list, setList] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [employeesize, setEmployeesize] = useState();

  useEffect(() => {
    if (user.tn) {
      API.getEmployeeItemSize({ tn: user.tn })
        .then((res) => {
          setList(_.orderBy(res, ["itemtypeid", "itemname"]));
        })
        .catch(() => {
          setList([]);
        });

      API.getEmployeeHeight(user.tn)
        .then((res) => {
          setEmployeesize(res.height);
        })
        .catch(() => {
          setEmployeesize(null);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.tn]);

  return (
    <div className="flex flex-col md:flex-row gap-2 ">
      <div className="md:w-1/4">
        <div className="w-full md:max-w-lg min-h-[150px] flex border">
          <div className="w-1/3 flex flex-col items-center justify-center gap-2 font-semibold rounded-l-2xl text-center">
            <Image src="/img/height.jpg" alt="Image" width="30" height="30" />
          </div>
          <div className="w-2/3 border-l rounded-r-2xl">
            <table className="w-full">
              <thead>
                <tr>
                  <th className="p-1 text-center">Биеийн өндөр /см/</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="p-1 text-center">
                    <InputNumber
                      // key={el.size}
                      min={120}
                      max={210}
                      placeholder="Өндрийн хэмжээ см-р оруулна уу"
                      className="w-full text-black"
                      value={employeesize}
                      onChange={(value) => {
                        setEmployeesize(value);
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="p-1 text-center border">
                    <button
                      className="w-full py-2 flex items-center justify-center font-semibold text-violet-500 border-2 border-violet-500 rounded-md hover:bg-violet-500 hover:text-white focus:outline-none duration-300 "
                      onClick={() => {
                        API.postEmployeeSize({
                          tn: user.tn,
                          height: employeesize,
                        });
                        Swal.fire({
                          icon: "success",
                          title: "Амжилттай хадгалагдлаа.",
                          showConfirmButton: false,
                          timer: 1500,
                        });
                      }}
                    >
                      <i className="fas fa-save" />
                      <span className="ml-2">Хадгалах</span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="text-justify p-2">
          <span className="text-blue-600">Тайлбар:</span> Хэрэв хамгаалах
          хэрэгслийн нормын мэдээлэл байхгүй бол бүтцийн нэгжийн ХАБЭА
          мэргэжилтэн болон ХАБЭА-н хэлтсийн хувийн хамгаалах хэрэгслийн норм
          хариуцсан мэргэжилтэнтэй холбогдоно уу
        </div>
      </div>

      <div className="md:w-2/4">
        <ResponsiveDataTable
          scrollable
          dataKey="id"
          size="small"
          stripedRows
          showGridlines
          className="text-xs w-full"
          // multiSortMeta={multiSortMeta}
          scrollHeight={window.innerHeight - 255}
          responsiveLayout="scroll"
          value={list}
          header={
            <div>
              <div className="md:max-w-[230px]">
                <Input
                  placeholder="Хайх..."
                  // prefix={<SearchOutlined />}
                  className="w-full rounded-lg"
                  // value={searchWerhouse}
                  // onChange={(e) => setSearchWerhouse(e.target.value)}
                />
              </div>
            </div>
          }
          emptyMessage={
            <div className="text-xs text-orange-500 italic font-semibold">
              Мэдээлэл олдсонгүй...
            </div>
          }
          rowGroupMode="subheader"
          groupRowsBy="itemtypeid"
          rowGroupHeaderTemplate={(data) => {
            return (
              <React.Fragment>
                <span className="text-xs font-semibold">
                  {data.itemtypename}
                </span>
              </React.Fragment>
            );
          }}
        >
          <Column
            align="center"
            header="№"
            field="ordern"
            className="text-xs"
            headerClassName="flex items-center justify-center"
            bodyClassName="flex items-center justify-center"
            style={{ minWidth: "30px", maxWidth: "30px" }}
            body={(data, options) => options.rowIndex + 1}
          />
          <Column
            header="Хамгаалах хэрэгслийн нэр"
            field="itemname"
            className="text-xs"
            headerClassName="flex items-center justify-center"
            // style={{ minWidth: "150px", maxWidth: "150px" }}
          />
          <Column
            header="Размер"
            className="text-xs"
            headerClassName="flex items-center justify-center"
            style={{ minWidth: "80px", maxWidth: "80px" }}
            body={(data) => {
              if (data.sizemin && data.sizemax) {
                return (
                  <Select
                    size="small"
                    showSearch={false}
                    className="w-full"
                    disabled={data.isclosed}
                    value={data.size}
                    align="center"
                    onChange={(value) => {
                      var result = list;
                      var index = _.findIndex(result, {
                        itemid: data.itemid,
                      });
                      result[index].size = value;
                      setList(result);

                      setRefresh(refresh + 1);

                      API.postEmployeeItemSize({
                        tn: user.tn,
                        itemid: data.itemid,
                        size: value,
                      });
                    }}
                  >
                    {_.map(
                      _.range(
                        data.sizemin,
                        data.sizemax + data.sizestep,
                        data.sizestep
                      ),
                      (i) => {
                        return (
                          <Select.Option
                            key={"key_" + data.itemid + "_" + i}
                            value={i}
                            className="text-center"
                          >
                            {i}
                          </Select.Option>
                        );
                      }
                    )}
                  </Select>
                );
              } else return null;
            }}
          />
          <Column
            header="Хугацаа"
            field="time"
            className="text-xs"
            headerClassName="flex items-center justify-center"
            bodyClassName="flex items-center justify-center"
            style={{ minWidth: "70px", maxWidth: "70px" }}
          />
          <Column
            header="Нэгж"
            field="unitname"
            className="text-xs"
            headerClassName="flex items-center justify-center"
            bodyClassName="flex items-center justify-center"
            style={{ minWidth: "70px", maxWidth: "70px" }}
          />
        </ResponsiveDataTable>
      </div>

      <div className="md:w-1/4 overflow-auto">
        <table className="w-full text-xs border-2">
          <thead>
            <tr>
              <th className="p-1 w-10 text-center border-2" colSpan={5}>
                Хувцасны размерын лавлах хэмжээ
              </th>
            </tr>
            <tr>
              <th className="p-1 w-10 text-center">RU</th>
              <th className="p-1 w-10 text-center border-x border-b">INT</th>
              <th className="p-2 w-20 text-center border-x border-b">
                Цээжний тойрог
              </th>
              <th className="p-2 w-20 text-center border-b border-x ">
                Бүсэлхийн тойрог
              </th>
              <th className="p-2 w-20 text-center border-b ">Ташааны тойрог</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="p-1 text-center border-y">40</td>
              <td className="p-1 text-center border">XS</td>
              <td className="p-1 text-center border">82</td>
              <td className="p-1 text-center border">60</td>
              <td className="p-1 text-center border">83</td>
            </tr>
            <tr>
              <td className="p-1 text-center border-y">42</td>
              <td className="p-1 text-center border">S</td>
              <td className="p-1 text-center border">86</td>
              <td className="p-1 text-center border">66</td>
              <td className="p-1 text-center border">87</td>
            </tr>
            <tr>
              <td className="p-1 text-center border-y">44</td>
              <td className="p-1 text-center border">S/M</td>
              <td className="p-1 text-center border">90</td>
              <td className="p-1 text-center border">70</td>
              <td className="p-1 text-center border">92</td>
            </tr>
            <tr>
              <td className="p-1 text-center border-y">46</td>
              <td className="p-1 text-center border">M</td>
              <td className="p-1 text-center border">94</td>
              <td className="p-1 text-center border">76</td>
              <td className="p-1 text-center border">96</td>
            </tr>
            <tr>
              <td className="p-1 text-center border-y">48</td>
              <td className="p-1 text-center border">M/L</td>
              <td className="p-1 text-center border">96</td>
              <td className="p-1 text-center border">82</td>
              <td className="p-1 text-center border">100</td>
            </tr>
            <tr>
              <td className="p-1 text-center border-y">50</td>
              <td className="p-1 text-center border">L</td>
              <td className="p-1 text-center border">98</td>
              <td className="p-1 text-center border">88</td>
              <td className="p-1 text-center border">104</td>
            </tr>
            <tr>
              <td className="p-1 text-center border-y">52</td>
              <td className="p-1 text-center border">L/XL</td>
              <td className="p-1 text-center border">100</td>
              <td className="p-1 text-center border">94</td>
              <td className="p-1 text-center border">108</td>
            </tr>
            <tr>
              <td className="p-1 text-center border-y">54</td>
              <td className="p-1 text-center border">XL</td>
              <td className="p-1 text-center border">104</td>
              <td className="p-1 text-center border">100</td>
              <td className="p-1 text-center border">112</td>
            </tr>
            <tr>
              <td className="p-1 text-center border-y">56</td>
              <td className="p-1 text-center border">XXL</td>
              <td className="p-1 text-center border">108</td>
              <td className="p-1 text-center border">104</td>
              <td className="p-1 text-center border">116</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Size;
